import { FC } from 'react';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { FeedbackModal, FeedbackModalProps } from '.';
import { Button } from '../../button';
import { StyledDangerButton } from '../styled-danger-button';

export interface ConfirmationModalProps
  extends Omit<FeedbackModalProps, 'actions'> {
  confirmLabel: string;
  cancelLabel: string;
  onConfirm?: () => void;
  onCancel: () => void;
  /** Visual variant — 'danger' shows red confirm button */
  variant?: 'default' | 'danger';
  /** Loading state on confirm button */
  isLoading?: boolean;
}

export const ConfirmationModal: FC<ConfirmationModalProps> = ({
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  icon,
  variant = 'default',
  isLoading = false,
  ...rest
}) => {
  const ConfirmButton = variant === 'danger' ? StyledDangerButton : Button;

  return (
    <FeedbackModal
      showCloseButton={false}
      icon={icon || <HelpOutlineRoundedIcon fontSize="large" />}
      actions={
        <>
          <Button
            label={cancelLabel}
            variant="tertiary"
            onClick={() => onCancel()}
            disabled={isLoading}
          />
          <ConfirmButton
            label={confirmLabel}
            variant="primary"
            onClick={onConfirm}
            disabled={isLoading}
            aria-busy={isLoading}
            testID="context-modal-confirm-button"
          />
        </>
      }
      onClose={() => onCancel()}
      {...rest}
    />
  );
};
